/* v8 ignore next */
import React from "react";

export const TestContainer: React.FunctionComponent = () => {
    return (
        <div>
            <h3> Test Container </h3>
        </div>
    );
};
